module.exports = __webpack_public_path__ + "static/img/aplic0.67fd1ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/aplic0.jpg
// module id = Ymaq
// module chunks = 0